import React, { Component } from "react";
import Dock from "react-dock";
import { gql } from "@apollo/client";
import { apolloClient } from "../../index";
import "./Files.scss";
import FileLargeItems from "../../components/FileExplorer/FileLargeItems/FileLargeItems";
import FileListView from "../../components/FileExplorer/FileListView/FileListView";
import SideBar from "../../components/SideBar/SideBar";
import RightArrow from "../../assets/icons/arrows/right_arrow.svg";
import DocumentExplorer from "../../components/DocumentExplorer/DocumentExplorer";
import FolderExplorer from "../../components/FolderExplorer/FolderExplorer";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import {
  mapStateToProps,
  mapDispatchToProps,
} from "../../common/UserDataReducer";
import SearchExplorer from "../../components/SearchExplorer/SearchExplorer";

class Files extends Component {
  state = {
    isVisible: true,
    dockSize: 0.27,
    rootFolders: [],
    subs: [],
    newSub: [],
    subFolders: {},
    quickAccess: {},
    recentlyEdited: {},
    recentPinFolder: {},
    recentPinId: "",
    isEditingASubFolder: false,
    isFoldersForUserLoading: true,
  };
  handleIsEditingASubFolder = (isEditingASubFolder = false) => {
    this.setState({
      isEditingASubFolder,
    });
  };
  handleViewSidebar = () => this.setState({ isVisible: !this.state.isVisible });

  componentDidMount() {
    this.fetchFoldersForUser();
  }

  fetchFoldersForUser = () => {
    this.setState({
      isFoldersForUserLoading: true,
    });
    apolloClient
      .query({
        query: gql`
          query foldersForUser {
            foldersForUser {
              id
              title
              approvalRequired
              approvalLevels {
                id
                name
                users {
                  id
                  isActive
                  username
                  firstName
                  lastName
                  email
                  profile {
                    imageUrl: image
                  }
                }
                sequence
              }
              isArchive
              isRoot
              hasSubFolders
              description
              instruction
              color {
                id
              }
              createdBy {
                profile {
                  image
                  role {
                    id
                    name
                  }
                }
                id
                username
                firstName
                lastName
              }
              sharedFolder {
                id
                user {
                  id
                  email
                  username
                  firstName
                  lastName
                }
                userRole {
                  id
                  name
                }
              }
              pinnedFolder {
                user {
                  id
                }
                folder {
                  id
                  title
                }
              }
              modifiedTs
            }
          }
        `,
        variables: {},
      })
      .then((result) => {
        const roots = result.data.foldersForUser.filter(
          (root) => root.isRoot && !root.isArchive
        );
        const subs = result.data.foldersForUser.filter((root) => !root.isRoot);
        this.setState({ rootFolders: [...roots], subs: [...subs] }, () => {
          this.props.updateFolders({ ...this.state });
        });
      })
      .catch((e) => {})
      .finally(() => {
        this.setState({
          isFoldersForUserLoading: false,
        });
      });
  };

  getQuickAccess = (data) => {
    const folder = { ...data.createFolder.folder };
    const { color, id, modifiedTs, title, isRoot } = folder;
    const updateQuickAccess = {
      color,
      id,
      isRoot,
      modifiedTs,
      title,
    };

    this.setState({ quickAccess: updateQuickAccess });
  };

  getRecentlyEdited = (data) => {
    const folder = { ...data.createFolder.folder };
    const { color, id, modifiedTs, title, isRoot, createdBy, sharedFolder } =
      folder;
    const folderId = id;
    const modifiedBy = createdBy;
    const parentFolder = null;
    const userActionOnFolder = [
      { action: { name: "Created", __typename: "UserActivityType" } },
    ];
    const __typename = "FolderType";
    const recentlyEdited = {
      __typename,
      folderId,
      isRoot,
      title,
      color,
      modifiedTs,
      modifiedBy,
      parentFolder,
      sharedFolder,
      userActionOnFolder,
    };
    this.setState({ recentlyEdited });
  };

  getRecentPin = (data, pinId, parentId) => {
    if (Object.keys(data).length > 0) {
      const { color, id, modifiedTs, title, isRoot, parentFolder } = data;
      const updateRecentPinFolder = {
        color,
        id,
        isRoot,
        modifiedTs,
        title,
        parentFolder,
      };
      this.setState({
        recentPinFolder: updateRecentPinFolder,
        recentPinId: pinId,
      });

      if (parentFolder) {
        const rootFolders = [...this.props.rootFolders];
        const subFolders = { ...this.props.subFolders };
        subFolders[parentFolder.id].map((sub) => {
          if (sub.id === id) {
            if (
              sub.pinnedFolder.length === 0 ||
              sub.pinnedFolder.length === 1
            ) {
              sub.pinnedFolder.push({
                folder: {
                  id: id,
                  title: title,
                },
                user: {
                  id: this.props.currentUserInfo.id,
                },
              });
            } else {
              sub.pinnedFolder = [];
            }
          }
          return true;
        });
        this.props.updateFolders({
          rootFolders: rootFolders,
          subFolders: subFolders,
        });
      }
    } else {
      this.setState({ recentPinFolder: {}, recentPinId: pinId }, () => {
        if (parentId) {
          const rootFolders = [...this.props.rootFolders];
          const subFolders = { ...this.props.subFolders };
          subFolders[parentId].map((sub) => {
            if (sub.id === pinId) {
              sub.pinnedFolder = [];
            }
            return true;
          });
          this.props.updateFolders({
            rootFolders: rootFolders,
            subFolders: subFolders,
          });
        }
      });
    }
  };

  render() {
    let contentClass = this.state.isVisible ? " content open" : "content";
    return (
      <>
        <div className="files-wraper container-fluid" id="style-scroll">
          <div className="row">
            <div className="col-md custom-dock">
              <Dock
                className="temp-dock"
                position="left"
                dimMode="none"
                size={this.state.dockSize}
                defaultSize={0.27}
                isVisible={this.state.isVisible}
                onSizeChange={(size) => {
                  if (size >= 0.27) this.setState({ dockSize: size });
                }}
              >
                <SideBar
                  isOpen={this.state.isVisible}
                  toggleSidebar={this.handleViewSidebar}
                  getQuickAccess={this.getQuickAccess}
                  getRecentlyEdited={this.getRecentlyEdited}
                  getRecentPin={this.getRecentPin}
                  isLoading={this.state.isFoldersForUserLoading}
                  {...this.props}
                />
              </Dock>
            </div>
            <div
              className={[
                contentClass,
                "col-md justify-content-between d-flex",
              ].join(" ")}
            >
              {this.state.isVisible ? null : (
                <div
                  className="sidedrawer-line"
                  onClick={this.handleViewSidebar}
                >
                  <img height="12" width="12" src={RightArrow} alt="arrow" />
                </div>
              )}
              {this.props.location.pathname === "/files" ? (
                <div className="slick-slider-wrapper">
                  <FileLargeItems
                    itemsTitle="Quick Access"
                    isQuickAccess={true}
                    quickAccess={this.state.quickAccess}
                    {...this.props}
                  ></FileLargeItems>
                  <FileLargeItems
                    itemsTitle="Pinned Folders"
                    recentPinId={this.state.recentPinId}
                    recentPinFolder={this.state.recentPinFolder}
                    pinned={true}
                    {...this.props}
                  ></FileLargeItems>
                  <FileListView
                    itemsTitle="Recently Edited"
                    recentlyEdited={this.state.recentlyEdited}
                    {...this.props}
                  />
                </div>
              ) : null}
              {this.props.rootFolders.length > 0 ? (
                <Switch>
                  <Route
                    exact
                    path="/files/search/:tagName"
                    component={SearchExplorer}
                  />
                  <Route
                    exact
                    path="/files/:folderId"
                    render={(props) => (
                      <FolderExplorer
                        {...props}
                        isEditingASubFolder={this.state.isEditingASubFolder}
                        handleIsEditingASubFolder={
                          this.handleIsEditingASubFolder
                        }
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/files/:folderId/:subId"
                    render={(props) => (
                      <DocumentExplorer
                        {...props}
                        subs={this.state.subs}
                        isEditingASubFolder={this.state.isEditingASubFolder}
                        handleIsEditingASubFolder={
                          this.handleIsEditingASubFolder
                        }
                      />
                    )}
                  />
                  <Route
                    exact
                    path="/files/:folderId/:subId/:docId"
                    component={DocumentExplorer}
                  />
                </Switch>
              ) : null}
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Files);
